export const ZERO = 0; 
export const FIRST = 1;